import Addresses from 'core/form/Addresses'

interface IProps {
  form: string
}

const Address = (props: IProps) => <Addresses prefix='Shop.' form={props.form} validate showVisitLatitudeLongitude />

export default Address
